import Stage from '../stage/stage.vue';
import ResourceSvc from '@/services/resource.svc.js';
const request = new ResourceSvc();
import { EventBus } from '@/services/Event.js';
import { Popover } from 'element-ui';

export default {
    props: {
        currentClubId: Number,
        currentStandardType: [Number, String],
        currentBlockOrderNumber: [Number, String] 
    },
    name: 'ClubStandardLayout',
    components: {
        [Popover.name]: Popover,
        'stage': Stage,
    },
    data() {
        return {
            isProcessing: false,
            blockIndexIsUsed: false,
            all_stages: [
                {
                    label: 'Loading...',
                    levels: [
                        {
                            fields: [

                            ]
                        }
                    ]
                }
            ],
            selected_stage: {
                label: 'Loading...',
                levels: [
                    {
                        fields: [

                        ]
                    }
                ]
            },
            selected_stage_index: 0,
            standardTypeLoaded: null,
            clubName: null,
            isSaveAllowed: false,
            currentStatus: null,
            rejectedMessage: null,
            applicationStandardTypeLabel: 'Bronze'
        }
    },
    watch: {
        selected_stage: { // watch it
            immediate: true,
            handler(val, oldVal) {
                this.set_init_settings();
            }
        },
        id: {
            immediate: true,
            handler(val, oldVal) {
                if (val && val != oldVal) {
                    this.init();
                }
            }
        }
    },
    computed: {
        blockIndex() {
            if (this.$route.query && this.$route.query.blockIndex > 1 && !this.blockIndexIsUsed) {
                return Number(this.$route.query.blockIndex) - 1;
            }
            return this.selected_stage_index;
        },
        currentBlockIndexNumber() {
            if (this.currentBlockOrderNumber > 1) {
                return this.currentBlockOrderNumber - 1;
            }
            return this.blockIndex;
        },
        id() {
            if (this.currentClubId) {
                return this.currentClubId;
            }
            return this.$route.params.id;
        },
        standardType() {
            if (this.currentStandardType) {
                return this.currentStandardType;
            }
            return this.standardTypeLoaded;
        },
        blockId() {
            if (this.selected_stage) {
                return this.selected_stage.id;
            }
            return null;
        }
    },
    methods: {
        showSuccess(message) {
            if (!message) {
                message = 'Operation success!';
            }

            this.$notify({
                message: message,
                type: 'success',
                timeout: 1000
            });
        },
        console(message) {
            if (console && console.log) {
                if (message) {
                    console.log(message);
                }
                else {
                    var date = new Date();
                    console.log("-------> " + date.getMinutes() + ":" + date.getSeconds());
                }
            }
        },
        handler_click_change_tab(stage) {
            this.selected_stage = stage;
            this.selected_stage_index = this.all_stages.indexOf(stage);
            this.setStatus(this.selected_stage);
        },
        setStatus(stage) {
            this.rejectedMessage = stage.rejectedMessage;
            this.currentStatus = stage.currentStatus;
        },
        to_top() {
            window.scrollTo(188, 188);
        },
        loadData() {
            var self = this;
            if (self.isProcessing) {
                return;
            }
            self.isProcessing = true;
            if (self.all_stages && self.all_stages.length && self.all_stages[0].label != "Loading...") {
                self.all_stages = [];
                self.selected_stage = null;
                self.to_top();
            }
            let isAdminRequest = self.currentStandardType > 0;

            var getRequest = isAdminRequest ? request.getClubStandardQuestionsWithType(self.id, self.currentStandardType)
                : request.getClubStandardQuestions(self.id);
            getRequest
                .then(response => {
                    self.isProcessing = false;
                    if (response && response.body && response.body.isSuccess) {
                        self.standardTypeLoaded = response.body.outputData.currentStandardType;
                        self.applicationStandardTypeLabel = response.body.outputData.applicationStandardTypeLabel;
                        if (!isAdminRequest) {
                            self.clubName = response.body.outputData.clubName;
                            self.isSaveAllowed = response.body.outputData.isSaveAllowed;
                        }

                        self.prepareResponse(response.body.outputData.stages);
                    } else {
                        self.$showError(response.body.message);
                        self.all_stages = [{ label: 'Loading Failed', levels: [{ fields: [] }] }];
                        self.selected_stage = null;
                    }
                    self.to_top();
                },
                    () => {
                        self.isProcessing = false;
                        self.all_stages = [{ label: 'Loading Failed', levels: [{ fields: [] }] }];
                        self.selected_stage = null;
                        self.$showError();
                    });
        },
        prepareResponse(stages) {
            var self = this;
            self.all_stages = stages;

            if (self.all_stages && self.all_stages.length) {
                self.selected_stage_index = self.currentBlockIndexNumber;
                self.changeStage();
                self.$emit("update:currentBlockOrderNumber", null);
                self.blockIndexIsUsed = true;
            }
        },
        init() {
            this.selected_stage = null;
            this.selected_stage_index = 0;
            this.loadData();
        },
        changeStage() {
            if (this.all_stages && this.all_stages.length) {
                this.selected_stage = this.all_stages[this.selected_stage_index];
                this.setStatus(this.selected_stage);
            }
        },
        changeStatus() {
            self = this;
            self.isProcessing = true;
            request.postUpdateStatus({ blockId: self.selected_stage.id, clubId: self.id, newBlockStatus: self.currentStatus, rejectedMessage: self.rejectedMessage })
                .then(response => {
                    self.isProcessing = false;
                    if (!(response && response.body && response.body.isSuccess)) {
                        if (response && response.body && response.body.message) {
                            self.$showError(response.body.message);
                        } else {
                            self.$showError();
                        }
                    }
                    self.loadData();
                },
                    () => {
                        self.isProcessing = false;
                        self.$showError();
                        self.init();
                    });
        },
        setStage(indexChange) {
            this.selected_stage_index += indexChange;
            this.changeStage();
        },
        go_back() {
            this.setStage(-1);
        },
        cancel() {
            this.loadData();
        },
        go_next() {
            this.setStage(1);
        },
        get_all_valid_fields(stage) {
            if (!stage) {
                stage = this.selected_stage;
            }
            let result = [];
            var allSuccess = true;
            stage
                .levels
                .forEach(level => {
                    if (level.fields && level.fields.length) {
                        level.fields.forEach(field => {
                            if (!field.isHidden) {
                                if (allSuccess && field.warnings && field.warnings.length) {
                                    allSuccess = false;
                                }
                                result.push(field);
                            }
                        })
                    }
                });

            if (!allSuccess) {
                return false;
            }

            return result;
        },
        save() {
            var self = this;
            var data = self.get_all_valid_fields();
            if (data) {
                self.isProcessing = true;
                var promise = self.currentClubId ? request.postSaveClubStandardAnswersAdmin(self.id, self.blockId, data)
                    : request.postSaveClubStandardAnswers(self.id, self.blockId, data);
                promise
                    .then(response => self.process_save_result(response),
                        () => { self.isProcessing = false; self.$showError(); self.cancel(); })
            }
            else {
                this.$showError("Please check all the fields before saving data")
            }
        },
        process_save_result(response, skipReload) {
            this.isProcessing = false;
            if (response && response.body && response.body.isSuccess) {
                if (!skipReload) {
                    this.cancel();
                }
            }
            else {
                this.$showError(response.body.message);
            }
        },
        set_init_settings() {
        }
    },
    mounted() {
        var self = this;
        self.init();
        EventBus.$off('cs-layout-reload')
        EventBus.$on('cs-layout-reload', () => {
            self.init();
        });
    }
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/club-standard/layout/layout.js